function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m361.735 94.196 5.067-68.979-50.375 46.829 12.654 32.213z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 256.006,
  cy: 256,
  rx: 133.082,
  ry: 133.083,
  transform: "matrix(.987 -.16 .16 .987 -37.701 44.313)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182.931 104.259 12.572-32.007-50.575-46.9 5.136 68.779z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m294.335 97.583-38.329-97.583-38.329 97.583c12.297-2.976 25.13-4.564 38.329-4.564s26.032 1.588 38.329 4.564z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m505.588 312.965-86.628-59.096c.009.71.027 1.419.027 2.131 0 26.081-6.168 50.745-17.106 72.626z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m403.743 187.226 52.412-90.839-100.285 30.903c20.344 15.82 36.849 36.349 47.873 59.936z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m420.203 218.523 28.257 19.277 57.071-39.018-68.05-10.205z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m230.871 447.729 25.291 64.271 25.141-64.121-25.297-23.459z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m144.931 486.648 76.874-71.289c-25.8-5.531-49.355-17.181-69.061-33.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m290.206 415.36 76.874 71.289-7.812-104.649c-19.706 16.179-43.262 27.828-69.062 33.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m387.682 361.008 2.549 34.148 66.054 20.295-34.453-59.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m156.142 127.29-100.286-30.904 52.413 90.84c11.024-23.586 27.529-44.115 47.873-59.936z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m91.809 218.523-17.167-29.754-68.23 10.319 56.956 38.837z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m55.922 415.697 65.843-20.32 2.566-34.369-33.932-5.124z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m93.025 256c0-.713.018-1.421.027-2.132l-86.627 59.097 103.707 15.661c-10.939-21.881-17.107-46.545-17.107-72.626z"
}));

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.23fe7eb0.svg";
export { ForwardRef as ReactComponent };